import Home, { getStaticProps as getStaticHomeProps } from '../components/pages/Home';

export default Home;
export const getStaticProps = getStaticHomeProps;
